// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import jquery from 'jquery'
import $ from 'jquery'

import './http';

Vue.config.productionTip = false

//2022-10-30 Cookie设置与获取
import { lStorage, sStorage } from "@Comm/js/Storage"

//2022-02-19 新增:ElementUI库  开始
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
//2022-02-19 新增:ElementUI库  结束

//2022-02-22 新增:MuseUI库  开始
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
Vue.use(MuseUI);
// import 'muse-ui-message/dist/muse-ui-message.css';
// import Message from 'muse-ui-message';
// Vue.use(Message);
//2022-02-22 新增:MuseUI库  开始

//2022-10-17 新增:ElementUI库内的组件  开始
// import {
//   Pagination,
//   Dialog,
//   Autocomplete,
//   Dropdown,
//   DropdownMenu,
//   DropdownItem,
//   Menu,
//   Submenu,
//   MenuItem,
//   MenuItemGroup,
//   Input,
//   InputNumber,
//   Radio,
//   RadioGroup,
//   RadioButton,
//   Checkbox,
//   CheckboxButton,
//   CheckboxGroup,
//   Switch,
//   Select,
//   Option,
//   OptionGroup,
//   Button,
//   ButtonGroup,
//   Table,
//   TableColumn,
//   DatePicker,
//   TimeSelect,
//   TimePicker,
//   Popover,
//   Tooltip,
//   Breadcrumb,
//   BreadcrumbItem,
//   Form,
//   FormItem,
//   Tabs,
//   TabPane,
//   Tag,
//   Tree,
//   Alert,
//   Slider,
//   Icon,
//   Row,
//   Col,
//   Upload,
//   Progress,
//   Spinner,
//   Badge,
//   Card,
//   Rate,
//   Steps,
//   Step,
//   Carousel,
//   CarouselItem,
//   Collapse,
//   CollapseItem,
//   Cascader,
//   ColorPicker,
//   Transfer,
//   Container,
//   Header,
//   Aside,
//   Main,
//   Footer,
//   Timeline,
//   TimelineItem,
//   Link,
//   Divider,
//   Image,
//   Calendar,
//   Backtop,
//   PageHeader,
//   CascaderPanel,
//   Loading,
//   MessageBox,
//   Message,
//   Notification
// } from 'element-ui';

// Vue.use(Pagination);
// Vue.use(Dialog);
// Vue.use(Autocomplete);
// Vue.use(Dropdown);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
// Vue.use(Menu);
// Vue.use(Submenu);
// Vue.use(MenuItem);
// Vue.use(MenuItemGroup);
// Vue.use(Input);
// Vue.use(InputNumber);
// Vue.use(Radio);
// Vue.use(RadioGroup);
// Vue.use(RadioButton);
// Vue.use(Checkbox);
// Vue.use(CheckboxButton);
// Vue.use(CheckboxGroup);
// Vue.use(Switch);
// Vue.use(Select);
// Vue.use(Option);
// Vue.use(OptionGroup);
// Vue.use(Button);
// Vue.use(ButtonGroup);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(DatePicker);
// Vue.use(TimeSelect);
// Vue.use(TimePicker);
// Vue.use(Popover);
// Vue.use(Tooltip);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
// Vue.use(Form);
// Vue.use(FormItem);
// Vue.use(Tabs);
// Vue.use(TabPane);
// Vue.use(Tag);
// Vue.use(Tree);
// Vue.use(Alert);
// Vue.use(Slider);
// Vue.use(Icon);
// Vue.use(Row);
// Vue.use(Col);
// Vue.use(Upload);
// Vue.use(Progress);
// Vue.use(Spinner);
// Vue.use(Badge);
// Vue.use(Card);
// Vue.use(Rate);
// Vue.use(Steps);
// Vue.use(Step);
// Vue.use(Carousel);
// Vue.use(CarouselItem);
// Vue.use(Collapse);
// Vue.use(CollapseItem);
// Vue.use(Cascader);
// Vue.use(ColorPicker);
// Vue.use(Transfer);
// Vue.use(Container);
// Vue.use(Header);
// Vue.use(Aside);
// Vue.use(Main);
// Vue.use(Footer);
// Vue.use(Timeline);
// Vue.use(TimelineItem);
// Vue.use(Link);
// Vue.use(Divider);
// Vue.use(Image);
// Vue.use(Calendar);
// Vue.use(Backtop);
// Vue.use(PageHeader);
// Vue.use(CascaderPanel);

// Vue.use(Loading.directive);
//2022-10-17 新增:ElementUI库内的组件  结束

//动态头部
router.beforeEach((to, from, next) => {

/* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
//2022-10-30:登录成功后不再让用户进入登录 开始
function isLogin(){
     //2021-11-04:更新使用sessionstorage获取用户token
    if( sStorage.getItem('token')!=undefined && sStorage.getItem('token')!=""){
      console.log('已登录');
      if (navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          )) {
        next({
          path: '/M/Home'
        })
      }
      //  else {
      //   next({
      //     path: '/PC/Home'
      //   })
      // }
      return true;
    }
      return false;
}
//2022-10-30:登录成功后不再让用户进入登录 结束
//适配路由
  if (to.path === '/') {
    if(isLogin()) return;//2021-11-03:登录成功后不再让用户进入登录
    if (navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )) {
      next({
        path: '/M'
      })
    } else {
      next({
        path: '/PC'
      })
    }
  } else {
    var index = to.path.lastIndexOf("\/");
    var obj = to.path.substring(index + 1, to.path.length);
    var o_Head = to.path.substring(0, index + 1);
    // console.log(":"+index);
    // console.log(":"+obj);
    // console.log(":"+o_Head);
    if (navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )) {
          // console.log(":"+sStorage.getItem('token'));
          if ((sStorage.getItem('token')==undefined || sStorage.getItem('token')=="")&&index > 0) {
            next({path: '/M'})
            return;
          }
          if (o_Head === '/M/' || obj === 'M') {
          // if (obj === 'M') {
            if (obj === 'M') if(isLogin()) return;//2021-11-03:登录成功后不再让用户进入登录
            next();
            return;
          }

          if (index > 0) next({path: '/M/' + obj})
          else next({path: '/M'})
      // if (o_Head === '/M/' || obj === 'M') {
      // // if (obj === 'M') {
      //   if (obj === 'M') if(isLogin()) return;//2021-11-03:登录成功后不再让用户进入登录
      //   next();
      //   return;
      // }

      // if (index > 0) next({path: '/M/' + obj})
      // else next({path: '/M'})
    }
    // else {
    //   if (o_Head === '/PC/' || obj === 'PC') {
    //     if (obj === 'PC') if(isLogin()) return;//2021-11-03:登录成功后不再让用户进入登录
    //     next();
    //     return;
    //   }
    //   if (index > 0) next({path: '/PC/' + obj})
    //   else next({path: '/PC'})
    //   // next({path: '/PC/' + obj})
    // }
  }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/OK_Scott/main.js